import {
  getObject,
  getList,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { GridOptionV1, GridOptionV1DTO } from "../types/gridOptionV1";
import { GridMultiSelectResultV1, GridMultiSelectResultV1DTO } from "./gridMultiSelectResultV1";

export interface GridMultiSelectRowResultV1DTO {
  gridOptionV1: GridOptionV1DTO;
  multiSelectResults: GridMultiSelectResultV1DTO[];
  totalResponses: number;
}

export class GridMultiSelectRowResultV1 {
  readonly isGridMultiSelectRowResultV1GridMultiSelectRowResultV1: boolean = true;

  readonly gridOptionV1: GridOptionV1;
  readonly multiSelectResults: GridMultiSelectResultV1[];
  readonly totalResponses: number;

  static readonly constraints = {
    "multiSelectResults": {
      "maxSize": 32,
    },
  }

  constructor(
  gridOptionV1: GridOptionV1, 
  multiSelectResults: GridMultiSelectResultV1[], 
  totalResponses: number
  ) {
    this.gridOptionV1 = gridOptionV1;
    GridMultiSelectRowResultV1.validateMultiSelectResults(multiSelectResults);
    this.multiSelectResults = multiSelectResults;
    this.totalResponses = totalResponses;
  }

  static fromDTO(dto: GridMultiSelectRowResultV1DTO): GridMultiSelectRowResultV1 {
    const gridOptionV1 = GridOptionV1.fromDTO(getObject(dto, "gridOptionV1", InvalidGridMultiSelectRowResultV1GridOptionV1Error));
    const multiSelectResults = getList<GridMultiSelectResultV1DTO, GridMultiSelectResultV1>(
      dto,
      "multiSelectResults",
      GridMultiSelectResultV1.fromDTO,
      InvalidGridMultiSelectRowResultV1MultiSelectResultsError
    );
    const totalResponses = getInt32(dto, "totalResponses", InvalidGridMultiSelectRowResultV1TotalResponsesError);
    return new GridMultiSelectRowResultV1(
      gridOptionV1,
      multiSelectResults,
      totalResponses
    );
  }

  toDTO(): GridMultiSelectRowResultV1DTO {
    const dto: GridMultiSelectRowResultV1DTO = {
        gridOptionV1: this.gridOptionV1.toDTO(),
        multiSelectResults: this.multiSelectResults.map((e: GridMultiSelectResultV1) => { return e.toDTO() }),
        totalResponses: this.totalResponses
    };
    return dto;
  }
  private static validateMultiSelectResults = (multiSelectResults: GridMultiSelectResultV1[]): void => {
    if(multiSelectResults.length > 32) {
      throw new InvalidGridMultiSelectRowResultV1MultiSelectResultsMaxSizeError(
        32,
        `Attribute multiSelectResults is too long. Size is ${multiSelectResults.length}. Max size is 32.`
      );
    }
  }
  
}

GridMultiSelectRowResultV1.prototype.toString = function toString(): string {
  return `GridMultiSelectRowResultV1(gridOptionV1='${this.gridOptionV1}',multiSelectResults='${this.multiSelectResults}',totalResponses='${this.totalResponses}')`;
};

export class InvalidGridMultiSelectRowResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectRowResultV1Error";
  }
}
export class InvalidGridMultiSelectRowResultV1GridOptionV1Error extends InvalidGridMultiSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectRowResultV1GridOptionV1Error";
  }
}

export class InvalidGridMultiSelectRowResultV1MultiSelectResultsError extends InvalidGridMultiSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectRowResultV1MultiSelectResultsError";
  }
}

export class InvalidGridMultiSelectRowResultV1MultiSelectResultsMaxSizeError extends InvalidGridMultiSelectRowResultV1MultiSelectResultsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectRowResultV1MultiSelectResultsMaxSizeError";
  }
}

export class InvalidGridMultiSelectRowResultV1TotalResponsesError extends InvalidGridMultiSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectRowResultV1TotalResponsesError";
  }
}
